import { IPagedResultsV1 } from '@gcl/react-core';
import { IApiBaseProps } from '@common/api.models';
import { envConfigs } from '@config/envConfigs';
import { createGetOptionsCustomPropsFn, createGetOptionsNoPropsFn } from '@common/selectOptions.services';
import { apiServerGet } from '@common/axios.services';
import { IRoleOption } from '@role/role.models';
import { IProjectRole, IProjectRoleOption } from './projectRole.models';

export const apiRoutes = {
  getProjectRolesWithUser: '/Roles/WithUsers',
  getProjectRoleOptions: '/Roles/Options',
  getRolesProjectRequest: '/Roles/ProjectRequest/Options',
  getRolesDistributionOptions: '/Roles/Distributions/Options',
  getGlobalProjectRolesWithUser: '/Roles/Global/WithUsers',
  getGlobalRoleOptions: '/Roles/Global/Options',
};

export interface IGetProjectRolesWithUserProps extends IApiBaseProps {
  companyId: number;
}

export const getProjectRolesWithUserAsync = async (
  props: IGetProjectRolesWithUserProps,
): Promise<IPagedResultsV1<IProjectRole>> => {
  const result = await apiServerGet<IPagedResultsV1<IProjectRole>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.getProjectRolesWithUser}`,
    {
      params: { ...props },
    },
  );
  return result.data;
};

export const getGlobalProjectRolesWithUserAsync = async (): Promise<IPagedResultsV1<IProjectRole>> => {
  const result = await apiServerGet<IPagedResultsV1<IProjectRole>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.getGlobalProjectRolesWithUser}`,
  );
  return result.data;
};

export const getGlobalRoleOptionsAsync = createGetOptionsNoPropsFn<IRoleOption>(apiRoutes.getGlobalRoleOptions);

export interface IGetProjectRoleOptionsProps extends IApiBaseProps {
  companyTypeId: number;
  organizationTypeId: number;
  shouldIncludeHidden?: boolean;
}

export const getProjectRoleOptionsAsync = async (
  props: IGetProjectRoleOptionsProps,
): Promise<IPagedResultsV1<IProjectRoleOption>> => {
  const result = await apiServerGet<IPagedResultsV1<IProjectRoleOption>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.getProjectRoleOptions}`,
    {
      params: { ...props },
    },
  );
  return result.data;
};

export interface IGetProjectRequestRoleOptionsProps {
  projectId?: number;
  companyTypeId?: number;
  organizationTypeId?: number;
  shouldIncludeHidden?: boolean;
}
export const getRolesProjectRequestAsync = async (
  props: IGetProjectRequestRoleOptionsProps,
): Promise<IPagedResultsV1<IProjectRoleOption>> => {
  const result = await apiServerGet<IPagedResultsV1<IProjectRoleOption>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.getRolesProjectRequest}`,
    {
      params: { ...props },
    },
  );
  return result.data;
};

export interface IGetRoleDistributionOptionsProps extends IApiBaseProps {
  companyTypeId?: number;
  organizationTypeId?: number;
}
export const getRoleDistributionOptionsAsync = createGetOptionsCustomPropsFn<
  IProjectRoleOption,
  IGetRoleDistributionOptionsProps
>(apiRoutes.getRolesDistributionOptions);
